export default {
  offer: "Offer",
  draft: "Draft",
  readyToSend: "Ready to send",
  sent: "Sent",
  overdue: "Overdue",
  paid: "Paid",
  reminded: "Reminder sent",
  irrecoverable: "Irrecoverable",
  credited: "Credited",
}
